import React from "react";

import PageTitle from "components/PageTitle";
// import Link from "components/common/Link";
// import HistoryIcon from "@mui/icons-material/HistoryOutlined";
import { tracker } from "library/tracker";
import PrimeInvestMoreContainer from "containers/jarivsPrime/PrimeInvestMore";

const PrimeInvestMore = () => {
  React.useEffect(() => {
    tracker.pageView();
  }, []);

  // const rightData = () => (
  //     <>
  //         <HistoryIcon sx={{ fontSize: 20, color: "primary.main" }} />
  //         <Link
  //             href="/customer/profile"
  //             variant="small"
  //             sx={{ fontWeight: "medium", textDecoration: "none" }}>
  //             Transaction
  //         </Link>
  //     </>
  // );

  return (
    <>
      <PageTitle
        heading="Invest More"
        subheading="How would you like to invest?"
        // endContent={rightData}
      />
      <PrimeInvestMoreContainer investmentType="LUMPSUM" />
    </>
  );
};

export default PrimeInvestMore;
